import { z } from 'zod';
export var InteractionTypeEnum;
(function (InteractionTypeEnum) {
    InteractionTypeEnum["CallCenterInteraction"] = "call-center-interaction";
    InteractionTypeEnum["FbmsInteraction"] = "fbms-interaction";
    InteractionTypeEnum["MedicalInsight"] = "medical-insight";
    InteractionTypeEnum["DocumentedInterest"] = "documented-interest";
})(InteractionTypeEnum || (InteractionTypeEnum = {}));
export const InteractionTypesMap = {
    [InteractionTypeEnum.CallCenterInteraction]: 'Call Center Interaction',
    [InteractionTypeEnum.FbmsInteraction]: 'MSL Interaction',
    [InteractionTypeEnum.MedicalInsight]: 'Medical Insight',
    [InteractionTypeEnum.DocumentedInterest]: 'Documented Interest',
};
export const InteractionTypeModel = z.nativeEnum(InteractionTypeEnum);
export var InteractionSubTypeEnum;
(function (InteractionSubTypeEnum) {
    InteractionSubTypeEnum["Introduction"] = "introduction";
    InteractionSubTypeEnum["Other"] = "other";
    InteractionSubTypeEnum["ScientificExchange"] = "scientific-exchange";
    InteractionSubTypeEnum["GeneralInquiry"] = "general-inquiry";
    InteractionSubTypeEnum["GlobalComplaint"] = "global-complaint";
    InteractionSubTypeEnum["MIR"] = "mir";
    InteractionSubTypeEnum["Settlement"] = "settlement";
})(InteractionSubTypeEnum || (InteractionSubTypeEnum = {}));
;
export const InteractionSubTypeModel = z.nativeEnum(InteractionSubTypeEnum);
export var CallCenterSource;
(function (CallCenterSource) {
    CallCenterSource["Chat"] = "chat";
    CallCenterSource["Email"] = "email";
    CallCenterSource["Fax"] = "fax";
    CallCenterSource["iConnect"] = "iConnect";
    CallCenterSource["Legend"] = "legend";
    CallCenterSource["Mail"] = "mail";
    CallCenterSource["Mobile"] = "mobile";
    CallCenterSource["Phone"] = "phone";
    CallCenterSource["Relypsa"] = "relypsa";
    CallCenterSource["USWeb"] = "US Web";
    CallCenterSource["Veeva"] = "Veeva";
    CallCenterSource["WalkIn"] = "walk-in";
    CallCenterSource["Web"] = "web";
})(CallCenterSource || (CallCenterSource = {}));
